export const MessageButton = {
    OptIn: 'opt-in',
    OptOut: 'opt-out',
    Decline: 'decline',
    Accept: 'accept',
    Ok: 'ok',
} as const;

export type MessageButton = typeof MessageButton[keyof typeof MessageButton];

export const ExpiredBonusStatus = {
    New: 'new',
    Used: 'inprogress',
} as const;
export type ExpiredBonusStatus = typeof ExpiredBonusStatus[keyof typeof ExpiredBonusStatus];

export interface MessageModalData {
    title: string;
    description: string;
    imgSrc: string;
}

export const MessageBonusType = {
    FreeSpins: 'Free Spins',
    BonusFunds: 'Bonus Funds',
    Wagering: 'Wagering',
    CashBonus: 'Cash Bonus',
} as const;
export type MessageBonusType = typeof MessageBonusType[keyof typeof MessageBonusType];

export const MessageBonusDomain = {
    Gaming: 'gaming',
    Sport: 'sport',
} as const;
export type MessageBonusDomain = typeof MessageBonusDomain[keyof typeof MessageBonusDomain];
